import { render, staticRenderFns } from "./QuotaManage.vue?vue&type=template&id=fb385a42&scoped=true&"
import script from "./QuotaManage.vue?vue&type=script&lang=js&"
export * from "./QuotaManage.vue?vue&type=script&lang=js&"
import style0 from "./QuotaManage.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./QuotaManage.vue?vue&type=style&index=1&id=fb385a42&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb385a42",
  null
  
)

component.options.__file = "QuotaManage.vue"
export default component.exports